import type { ReactNode } from "react";

export function QuotesTextLink(props: {
  onClick: (() => void) | undefined;
  children: ReactNode;
  /** Forwarded to the button so tests can target the action rather than match
   *  its text — several of these links sit inside the same quote column. */
  "data-testid"?: string | undefined;
}) {
  return (
    <button
      type="button"
      onClick={props.onClick}
      {...(props["data-testid"] !== undefined && {
        "data-testid": props["data-testid"],
      })}
      className="inline-flex cursor-pointer items-center gap-1 text-sm font-normal text-brand-text hover:underline"
    >
      {props.children}
    </button>
  );
}
